const comments = [
  {
    name: '综艺小达人',
    text: '极速影院真的太良心了！画质清晰还不卡，每天午休时间必刷一集脱口秀大会，笑到同事以为我疯了哈哈。最关键是完全免费，强烈推荐给所有综艺爱好者！',
    time: '3 天前',
    show: '脱口秀大会',
    avatar: 'ri-user-3-fill',
  },
  {
    name: '追综不熬夜',
    text: '从音乐综艺到户外真人秀，片库真的很全。而且更新速度超快，电视台刚播完这边就能看了，画质还是1080P的，看歌手2024的舞台细节超清楚的。',
    time: '1 周前',
    show: '歌手 2024',
    avatar: 'ri-user-3-fill',
  },
  {
    name: '快乐肥宅水',
    text: '之前一直在找能免费看综艺的地方，终于找到极速影院了！手机上看也很流畅，通勤路上追完了整季密室大逃脱。希望平台越做越好，会一直支持的！',
    time: '2 周前',
    show: '密室大逃脱',
    avatar: 'ri-user-3-fill',
  },
  {
    name: '深夜观影者',
    text: '深色模式对夜间追综党太友好了！经常躺床上看到半夜。街舞总决赛那期看了三遍，舞台效果在高清画质下太震撼了。给极速影院团队点赞！',
    time: '3 周前',
    show: '这！就是街舞',
    avatar: 'ri-user-3-fill',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            观众评价
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            真实的观众反馈，听听大家怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {comments.map((comment, index) => (
            <div key={index} className="bg-background-50 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                  <i className={`${comment.avatar} text-secondary-600 text-base`}></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground-950">{comment.name}</p>
                  <p className="text-[11px] text-foreground-500">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.text}</p>
              <div className="mt-3 pt-3 border-t border-background-200">
                <span className="text-[11px] text-primary-600 font-medium">
                  <i className="ri-play-circle-line mr-1"></i>
                  正在看《{comment.show}》
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}